import { useEffect, useState } from "react"

import { toast } from "sonner"

import { MarkdownDisplay } from "@/components/displays/MarkdownDisplay"
import { generateMarkdownFromMapping } from "@/lib/file"

interface JsonDisplayProps {
    content: string
    mapping: Record<string, string | { template: string; transform: (value: any) => any }>
}

export function JsonDisplay({ content, mapping }: Readonly<JsonDisplayProps>) {
    const [markdown, setMarkdown] = useState("")

    useEffect(() => {
        handleConvert()
    }, [content])

    const handleConvert = () => {
        if (!content || content.length === 0) {
            setMarkdown("")
            return
        }

        try {
            setMarkdown(generateMarkdownFromMapping(JSON.parse(content), mapping))
        } catch (err) {
            const error = err as Error
            toast.error(`${error.name}`, {
                description: `${error.message}`,
                duration: 5000
            })
            setMarkdown("")
        }
    }

    return (
        <div className='w-full h-full overflow-auto p-2'>
            {
                markdown
                    ? (
                        <MarkdownDisplay content={markdown} />
                    ) : (
                        <span className="text-gray-500">No JSON data available</span>
                    )
            }
        </div>
    )
}